import { createSelector } from "reselect";

import getRunningProcesses from "../base_getters/get_running_processes";

const getRunningExportProcesses = createSelector([
  getRunningProcesses
], (runningProcesses) => runningProcesses.exports || null);

export default getRunningExportProcesses;
